export default "__VITE_ASSET__B0Gd0eL2__"